import { gql } from '@apollo/client';

export const HIGHLIGHT_FIELDS = gql`
  fragment HighlightFields on HighlightNode {
    start
    end
    text
    part
    tag
    color
  }
`;
